module.exports = __webpack_public_path__ + "img/er-2.3895ed27.png";